module.exports = __webpack_public_path__ + "static/media/empty.b56c64ff.svg";